"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QontoStepIcon = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const QontoStepIcon = ({ active, completed, icon, }) => {
    return (react_1.default.createElement(styles_1.Container, { active: active, completed: completed },
        react_1.default.createElement(styles_1.ActiveIconStyled, null,
            completed && react_1.default.createElement(styles_1.CheckStyled, null),
            active && (react_1.default.createElement(styles_1.ActiveIconStyled, null,
                react_1.default.createElement(styles_1.InnerActiveIconStyled, null))),
            !active && !completed && react_1.default.createElement(styles_1.Icon, null, icon))));
};
exports.QontoStepIcon = QontoStepIcon;
//# sourceMappingURL=index.js.map